var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-list-placeholder",style:({width:_vm.width,margin:_vm.margin})},[_c('el-image',{staticClass:"empty-img",attrs:{"src":_vm.img,"fit":"fill"}}),_vm._v(" "),_c('div',{staticClass:"text"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }